import React, { useContext } from 'react';
import QuestionarioContextProvider from '../../../../hooks/useQuestionario';
import { Row, Button, Widget, FormSubmitButton, MasterDetailForm } from '@digital/ui';
import { Modal } from 'antd';

function ModalEnviarValidacaoContaResultado() {
  const { exibirModalEnviarValidacaoContaResultado, setExibirModalEnviarValidacaoContaResultado } = useContext(
    QuestionarioContextProvider,
  );
  const onDiscordar = () => {
    setExibirModalEnviarValidacaoContaResultado(false);
  };

  return (
    <>
      {exibirModalEnviarValidacaoContaResultado && (
        <Modal
          title="Confirmar"
          width="680px"
          visible={exibirModalEnviarValidacaoContaResultado}
          onCancel={onDiscordar}
          className="chat-modal"
          footer={[
            <Button key="discordarBtn" type="link" onClick={onDiscordar}>
              Não
            </Button>,
            <FormSubmitButton noIcon key="concordarBtn" type="primary">
              Sim
            </FormSubmitButton>,
          ]}>
          <MasterDetailForm>
            <Widget>
              <Row>
                <p style={{ textAlign: 'center', paddingTop: '50px', paddingBottom: '50px' }}>
                  Sua demanda será validada pelo Planejamento e Controle, deseja seguir com a validação?
                </p>
              </Row>
            </Widget>
          </MasterDetailForm>
        </Modal>
      )}
    </>
  );
}

export default ModalEnviarValidacaoContaResultado;
